export const getHostname = () => {
	if (typeof window !== 'undefined') {
		return `https://${window.location.hostname}`;
	}
	return process.env.NEXT_PUBLIC_CANONICAL_DOMAIN
};
